module.exports = __webpack_public_path__ + "static/Tips-to-Breaking-the-Slump-1c3cd0e91cec2b45b47ac45527584a1c.webp";